module.exports = __webpack_public_path__ + "static/media/video_bg.1aaf50b9.jpg";